import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiChevronRight } from 'react-icons/hi';

const Breadcrumb = ({ items, className = 'flex items-center space-x-2 text-sm font-medium text-slate-600 mb-4' }) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <HiChevronRight className="text-slate-400" />}
          {index === items.length - 1 ? (
            <span className="text-gray-400">{item.label}</span>
          ) : (
            <button
              onClick={() => item.path ? navigate(item.path, { state: item.state }) : navigate(-1)}
              className="transition-colors"
            >
              {item.label}
            </button>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb; 